import { useState } from 'react';
import { useToast } from '@chakra-ui/react';
import { apiSubmitMVRRequest } from 'api';
import type { MVRRequestPayload } from 'api';
import { getApiErrorMessage } from 'utils/apiFieldErrors';

interface SubmitResult {
  success: boolean;
  mvrOrderId?: number;
}

export const useMvrRequest = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const toast = useToast();

  const showErrorToast = (description: string) => {
    toast({
      title: 'Error Submitting MVR Request',
      description,
      status: 'error',
      duration: 5000,
      isClosable: true,
      position: 'top',
    });
  };

  const submitRequest = async (
    payload: MVRRequestPayload,
  ): Promise<SubmitResult> => {
    setIsSubmitting(true);

    try {
      const response = await apiSubmitMVRRequest(payload);

      if (response.status === 'service_unavailable') {
        showErrorToast(response.error || 'Service is currently unavailable');
        return { success: false };
      }

      return { success: true, mvrOrderId: response.mvr_order_id };
    } catch (error: any) {
      showErrorToast(getApiErrorMessage(error, 'Failed to submit MVR request'));
      return { success: false };
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    submitRequest,
    isSubmitting,
  };
};
